var render = function render(){var _vm=this,_c=_vm._self._c;return _c('report-mobile-shift-rows',{attrs:{"loading":_vm.loading.getDailyRestaurant,"rows":_vm.shiftRows,"stats":_vm.stats,"search":_vm.filters.search,"empty-icon":"mdi-leaf"}})
}
var staticRenderFns = []

export { render, staticRenderFns }